module.exports = __webpack_public_path__ + "static/img/sooka-subscription-cover.2ad2775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/sooka-subscription-cover.png
// module id = vSDU
// module chunks = 1